module.exports = __webpack_public_path__ + "img/applestore.834c306d.png";